import store from '@/store'
import router from '@/router'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'
import config from '@/config'

export default {
  install: (Vue, options) => {
    const firebaseApp = firebase.initializeApp(config.firebase)
    const auth = firebaseApp.auth()
    Vue.prototype.$firebase = firebaseApp
    Vue.prototype.$db = firebaseApp.firestore()
    Vue.prototype.$auth = {
      login: async (username, pass) => {
        return auth.signInWithEmailAndPassword(username, pass)
      },
      createRecapcha: function(elementId, callback) {
        if (window.recaptchaVerifier) {
          window.recaptchaVerifier.clear()
          window.recaptchaVerifier = null
        }
        window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(elementId, {
          size: 'invisible',
          callback,
        })
      },
      loginByPhone: async(phone) => {
        return auth.signInWithPhoneNumber(phone, window.recaptchaVerifier)
      },
      verifyPhoneCode(verificationId, code) {
        const credential = firebase.auth.PhoneAuthProvider.credential(verificationId, code)
        return auth.currentUser.updatePhoneNumber(credential)
      },
      logout: async () => {
        await auth.signOut()
        router.push('/user/login')
      },
      user() {
        return auth.currentUser
      },
    }
    auth.onAuthStateChanged(user => {
      store.commit('UPDATE_USER', { user })
      window.onAuthStateChanged && window.onAuthStateChanged()
    })
  },
}
